import CT from '@marketplace-ai/tags';
import { FormRow, FormSection, Select } from '~/components';

import { VISA_STATUS_OPTIONS, VISA_TYPE_OPTIONS } from './constants';

const TAGS = CT.profile.personalInfo.form;

export const VisaSection = () => {
  return (
    <section className="rounded-lg border border-grey-900 bg-grey-925 p-4 text-grey-100">
      <h2 className="mb-4 text-base font-semibold">Visa information</h2>
      <FormSection componentsPerLine={2}>
        <FormRow>
          <Select
            name={'visaStatus'}
            label={'Visa Status'}
            options={VISA_STATUS_OPTIONS}
            cyTag={TAGS.visaStatusDropdown}
          />
        </FormRow>
        <FormRow>
          <Select
            name={'visaType'}
            label={'Visa Type'}
            options={VISA_TYPE_OPTIONS}
            cyTag={TAGS.visaTypeDropdown}
          />
        </FormRow>
      </FormSection>
    </section>
  );
};
